import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { NgxExtendedPdfViewerModule, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgxExtendedPdfViewerModule, MatButtonModule, MatIconModule],
})
export class PdfViewerComponent {
    @Input() public fileUrl: string;
    @Input() public filename: string;
    @Input() public visible: boolean;

    @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter();

    constructor() {
        pdfDefaultOptions.doubleTapZoomFactor = '200%';
    }

    closePdfViewer() {
        this.visibleChange.emit(false);
    }
}
